// extracted by mini-css-extract-plugin
module.exports = {"text":"_1oaX0E9cYMF4n6D629DVvC","content":"_2272usRMTG33Ymrqay1QaG","card":"_3vOqP3rCXTKxQLxTKO0q7f"};